// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__fyBYj","firstName":"firstName__3C616","profileButton":"profileButton__29Q0S","buttonContainer":"buttonContainer__34KUQ"};